import { Typography } from '@mui/material';
import { ReactComponent as CheckIcon } from 'assets/img/icon-check.svg';
import classNames from 'classnames';
import useLocalizedData from 'hooks/useLocalizedData';
import { Accordion, Card } from 'react-bootstrap';
import ROAMING_NETWORK_INFO_LABELS from './RoamingNetworkInfo.labels';
import styles from './RoamingNetworkInfo.module.scss';

const RoamingNetworkInfo = ({ networkInfo, providersInfo, chargesInfo }) => {
  const [labels] = useLocalizedData(ROAMING_NETWORK_INFO_LABELS);

  return (
    <div className={styles.networkInfoContainer}>
      <div className="row gy-3">
        <div className="col-12 col-lg-6 col-xxl-4">
          <Accordion className={classNames(styles.servicesAccordion, 'black')}>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <div className={styles.servicesContainer}>
                  <Typography component="div" variant="h6" color="white" className="me-1">
                    {labels?.['servicesTitle']}
                  </Typography>
                  {networkInfo?.hasVoice && (
                    <Typography
                      component="span"
                      variant="subtitle1"
                      color="white"
                      className="py-1 px-2 me-1 border border-1 border-white"
                      sx={{ borderRadius: '.75rem' }}
                    >
                      {labels?.['networkVoice']}
                    </Typography>
                  )}
                  {networkInfo?.hasForthGen && (
                    <Typography
                      component="span"
                      variant="subtitle1"
                      color="white"
                      className="py-1 px-2 me-1 border border-1 border-white"
                      sx={{ borderRadius: '.75rem' }}
                    >
                      {labels?.['network4G']}
                    </Typography>
                  )}
                  {networkInfo?.hasFifthGen && (
                    <Typography
                      component="span"
                      variant="subtitle1"
                      color="white"
                      className="py-1 px-2 me-1 border border-1 border-white"
                      sx={{ borderRadius: '.75rem' }}
                    >
                      {labels?.['network5G']}
                    </Typography>
                  )}
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="row g-2">
                  {networkInfo?.hasVoice && (
                    <div className="col-6">
                      <Card className={styles.servicesCard}>
                        <Card.Body>
                          <CheckIcon className={styles.servicesCardCheck} />
                          <Card.Title as="div">
                            <Typography component="span" variant="subtitle1" color="white">
                              {labels?.['networkVoiceTitle']}
                            </Typography>
                          </Card.Title>
                          <Card.Text as="div">
                            <Typography component="span" variant="body2" color="white">
                              {labels?.['networkVoiceDesc']}
                            </Typography>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </div>
                  )}
                  {networkInfo?.hasForthGen && (
                    <div className="col-6">
                      <Card className={styles.servicesCard}>
                        <Card.Body>
                          <CheckIcon className={styles.servicesCardCheck} />
                          <Card.Title as="div">
                            <Typography component="span" variant="subtitle1" color="white">
                              {labels?.['network4GTitle']}
                            </Typography>
                          </Card.Title>
                          <Card.Text as="div">
                            <Typography component="span" variant="body2" color="white">
                              {labels?.['network4GDesc']}
                            </Typography>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </div>
                  )}
                  {networkInfo?.hasFifthGen && (
                    <div className="col-6">
                      <Card className={styles.servicesCard}>
                        <Card.Body>
                          <CheckIcon className={styles.servicesCardCheck} />
                          <Card.Title as="div">
                            <Typography component="span" variant="subtitle1" color="white">
                              {labels?.['network5GTitle']}
                            </Typography>
                          </Card.Title>
                          <Card.Text as="div">
                            <Typography component="span" variant="body2" color="white">
                              {labels?.['network5GDesc']}
                            </Typography>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </div>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
        <div className="col-12 col-lg-6 col-xxl-4">
          <Accordion className={styles.servicesAccordion}>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <Typography component="div" variant="h6" color="black" className="me-2">
                  {labels?.['providersTitle']}
                </Typography>
              </Accordion.Header>
              <Accordion.Body>
                {Array.isArray(providersInfo) &&
                  providersInfo.map((it, id) => (
                    <div className={styles.providerInfoItem} key={id}>
                      <Typography component="div" variant="h6" color="black" className="w-100">
                        {it.name}
                      </Typography>
                      {it.hasVoice && (
                        <div className={styles.providerInfoService}>
                          <CheckIcon className={styles.providerInfoServiceCheck} />
                          <Typography component="span" variant="subtitle1" color="black">
                            {labels?.['networkVoiceTitle']}
                          </Typography>
                        </div>
                      )}
                      {it.hasForthGen && (
                        <div className={styles.providerInfoService}>
                          <CheckIcon className={styles.providerInfoServiceCheck} />
                          <Typography component="span" variant="subtitle1" color="black">
                            {labels?.['network4GTitle']}
                          </Typography>
                        </div>
                      )}
                      {it.hasFifthGen && (
                        <div className={styles.providerInfoService}>
                          <CheckIcon className={styles.providerInfoServiceCheck} />
                          <Typography component="span" variant="subtitle1" color="black">
                            {labels?.['network5GTitle']}
                          </Typography>
                        </div>
                      )}
                    </div>
                  ))}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
        <div className="col-12 col-xxl-4">
          <Accordion className={styles.servicesAccordion}>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <Typography component="div" variant="h6" color="black" className="me-2">
                  {labels?.['chargeTitle']}
                </Typography>
              </Accordion.Header>
              <Accordion.Body>
                <div className={styles.chargesInfoItem}>
                  <Typography component="div" variant="subtitle1" color="black">{labels?.['chargesInfoOutgoingTitle']}</Typography>
                  <Typography component="div" variant="body2" color="black">{chargesInfo?.outgoing}</Typography>
                </div>
                <div className={styles.chargesInfoItem}>
                  <Typography component="div" variant="subtitle1" color="black">{labels?.['chargesInfoIncomingTitle']}</Typography>
                  <Typography component="div" variant="body2" color="black">{chargesInfo?.incoming}</Typography>
                </div>
                <div className={styles.chargesInfoItem}>
                  <Typography component="div" variant="subtitle1" color="black">{labels?.['chargesInfoSmsTitle']}</Typography>
                  <Typography component="div" variant="body2" color="black">{chargesInfo?.sms}</Typography>
                </div>
                <div className={styles.chargesInfoItem}>
                  <Typography component="div" variant="subtitle1" color="black">{labels?.['chargesInfoDataTitle']}</Typography>
                  <Typography component="div" variant="body2" color="black">{chargesInfo?.data}</Typography>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
    </div>
  );
};
export default RoamingNetworkInfo;
